import Routes from './routes';

require('../scss/app.scss');


if (!String.prototype.includes) {
    String.prototype.includes = function() {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

new Routes();



/** WEBPACK FOOTER **
 ** ./frontend/js/app.js
 **/